<template>
    <div>
        <div class="placeholder placeholder_inline placeholder_icon placeholder_date"
             @click="open = !open">
            {{ formattedDate }}

            <slot/>
            <Icon id="arrow-down"/>
        </div>
        <DatePicker
            v-click-outside="close"
            v-if="open"
            :inline="true"
            :value="value"
            v-on:input="v => $emit('input', v)"
            v-on:change="close"
            :clearable="false"
            :disabled-date="disabledTo(minDate)"
        />
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/ru';
import {dateToDMY, dateToLeadingZeroObject} from "@common/utils/date";

export default {
    name: "Calendar",
    components: {DatePicker},
    props: {
        value: {
            type: Date | null,
        },
        minDate: {
            type: Date | null,
            default: () => (new Date()),
        },
    },
    data() {
        return {
            open: false,
        };
    },
    computed: {
        formattedDate() {
            if (!this.value) {
                return 'Выберите дату';
            }

            return dateToDMY(this.value);
        }
    },
    methods: {
        close() {
            this.open = false;
        },
        disabledTo(minDate) {
            if (!minDate) return date => false;
            minDate.setHours(0, 0, 0, 0);

            return (date) => date < minDate;
        },
    }
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

.placeholder_date {
    cursor: pointer;
}

$primary-color: $green;

@import '~vue2-datepicker/scss/index.scss';
</style>